import type { SearchNode } from './types';

export const SEARCH_CONDITION_CHILD_LISTENERS = new WeakMap<SearchNode, () => void>();
